module.exports = __webpack_public_path__ + "img/map_1791447933192_59800.bbbc8294.gif";